export function UserAvatar({
  width,
  height,
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width || "84"}
      height={height || "84"}
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42 83.6668C65.0125 83.6668 83.6667 65.0127 83.6667 42.0002C83.6667 18.9877 65.0125 0.333496 42 0.333496C18.9875 0.333496 0.333332 18.9877 0.333332 42.0002C0.333332 65.0127 18.9875 83.6668 42 83.6668ZM54.5 33.6668C54.5 36.982 53.183 40.1615 50.8388 42.5057C48.4946 44.8499 45.3152 46.1668 42 46.1668C38.6848 46.1668 35.5054 44.8499 33.1612 42.5057C30.817 40.1615 29.5 36.982 29.5 33.6668C29.5 30.3516 30.817 27.1722 33.1612 24.828C35.5054 22.4838 38.6848 21.1668 42 21.1668C45.3152 21.1668 48.4946 22.4838 50.8388 24.828C53.183 27.1722 54.5 30.3516 54.5 33.6668ZM17 62.8335C19.9084 58.9497 23.6824 55.7977 28.0222 53.6278C32.3619 51.4579 37.148 50.3299 42 50.3335C46.852 50.3299 51.6381 51.4579 55.9779 53.6278C60.3176 55.7977 64.0916 58.9497 67 62.8335C64.0916 66.7173 60.3176 69.8693 55.9779 72.0392C51.6381 74.2091 46.852 75.3371 42 75.3335C37.148 75.3371 32.3619 74.2091 28.0222 72.0392C23.6824 69.8693 19.9084 66.7173 17 62.8335Z"
        fill="#959595"
      />
    </svg>
  );
}
